/**
 * @generated SignedSource<<f90dfe114387bbfdf57e18240a4227d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewQuery$variables = {
  widgetId: string;
};
export type WidgetRoutineOverviewQuery$data = {
  readonly widgetRoutineOverview: {
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewDataComponent_widgetRoutineOverview">;
  } | null;
};
export type WidgetRoutineOverviewQuery = {
  response: WidgetRoutineOverviewQuery$data;
  variables: WidgetRoutineOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetRoutineOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetRoutineOverview",
        "kind": "LinkedField",
        "name": "widgetRoutineOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetRoutineOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetRoutineOverview",
        "kind": "LinkedField",
        "name": "widgetRoutineOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "ownerTeam",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "inProgressOccasion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expireAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "calculateNoTasks",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "calculateNotCompletedStarted",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sequenceNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32ac4723605a31c12ac91e60e40b20f2",
    "id": null,
    "metadata": {},
    "name": "WidgetRoutineOverviewQuery",
    "operationKind": "query",
    "text": "query WidgetRoutineOverviewQuery(\n  $widgetId: ID!\n) {\n  widgetRoutineOverview(id: $widgetId) {\n    id\n    title\n    ...WidgetRoutineOverviewDataComponent_widgetRoutineOverview\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment WidgetRoutineOverviewDataComponent_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutineOverviewListItem_routine\n    inProgressOccasion {\n      expireAt\n      startAt\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetRoutineOverviewListItem_routineOccasion\n      id\n    }\n  }\n}\n\nfragment WidgetRoutineOverviewListItemExpireText_routineOccasion on RoutineOccasion {\n  startAt\n  expireAt\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n}\n\nfragment WidgetRoutineOverviewListItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    id\n    name\n  }\n}\n\nfragment WidgetRoutineOverviewListItem_routineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  sequenceNumber\n  ...WidgetRoutineOverviewListItemExpireText_routineOccasion\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n}\n"
  }
};
})();

(node as any).hash = "7c586b530c025347c80cd3360fa5550f";

export default node;
